import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_HOME_PAGE = {
	[LANGUAGE.en.short]: {
		title: '<span class="dark-background">We <span class="accelerate">bring</span> IT and Engineering</span><br> solutions together, creating a smarter future for everyone',
		explore: 'EXPLORE GOP',
		paragraph: 'An extensive suite of Global Portfolio Offers covering key Industries and Tech practices',
		info: 'Let’s innovate, optimize, and transform business with Sales success on Strategic offerings.',
		downloadPresentation: 'Create a new offer on GOP',
		publishedOffers: 'Recently published offers',
		lowDefinition: 'Download in Low Definition (PDF)',
		highDefinition: 'Download in High Definition (PPT)',
		copyFileLink: 'Copy file URL',
		successCopyFileLink: 'Successfully copied file URL'
	},
	[LANGUAGE.de.short]: {
		title: '<span class="dark-background">Wir <span class="accelerate">vereinen</span> IT- und Engineering-Lösungen </span><br> und gestalten gemeinsam eine smarte Zukunft für alle',
		explore: "GOP-ANGEBOTE ENTDECKEN",
		paragraph: 'Ein umfassendes globales Angebotsportfolio, das zentrale Branchen und technologische Kernbereiche abdeckt.',
		info: 'Lassen Sie uns mit Vertriebserfolgen bei strategischen Angeboten Ihr Geschäft erneuern, optimieren und umgestalten.',
		downloadPresentation: 'Neues Angebot in GOP erstellen',
		publishedOffers: 'Kürzlich veröffentlichte Angebote',
		lowDefinition: 'Download in niedriger Auflösung (PDF)',
		highDefinition: 'Download in hoher Auflösung (PPT)',
		copyFileLink: 'Datei-URL kopieren',
		successCopyFileLink: 'Datei-URL erfolgreich kopiert'
	},
	[LANGUAGE.fr.short]: {
		title: ' <span class="dark-background">Nous <span class="accelerate">apportons</span> des solutions en IT et ingénierie</span><br>, pour créer ensemble un avenir meilleur et plus innovant',
		explore: "EXPLORER LE GOP",
		paragraph: 'Notre portefeuille d\'offres mondiales couvrant nos industries et practices technologiques clés.',
		info: 'Innovons, optimisons et transformons les entreprises grâce au succès des ventes sur des offres stratégiques.',
		downloadPresentation: 'Créer une nouvelle offre sur le GOP',
		publishedOffers: 'Offres récemment publiees',
		lowDefinition: 'Télécharger en basse résolution (PDF)',
		highDefinition: 'Télécharger en haute définition (PPT)',
		copyFileLink: 'Copier l\'URL du fichier',
		successCopyFileLink: 'L\'URL du fichier a été copiée avec succès'
	},
	[LANGUAGE.it.short]: {
		title: '<span><span class="dark-background"><span class="accelerate">Uniamo</span> soluzioni IT e ingegneristiche,</span><br> con l’obiettivo di costruire un futuro più smart per tutti</span>',
		explore: "SCOPRI TUTTE LE NOSTRE SOLUZIONI GLOBALI",
		paragraph: 'Un\'ampia offerta di Soluzioni Globali relative a settori strategici e a molteplici metodologie tecnologiche.',
		info: 'Innovons, optimisons et transformons les entreprises grâce au succès des ventes sur des offres stratégiques.',
		downloadPresentation: 'Crea una nuova offerta su GOP',
		publishedOffers: 'Le Soluzioni Globali più recenti',
		lowDefinition: 'Scarica in bassa risoluzione (PDF)',
		highDefinition: 'Scarica in alta definizione (PPT)',
		copyFileLink: 'Copia URL file',
		successCopyFileLink: 'URL file copiato correttamente'
	},
	[LANGUAGE.ja.short]: {
		title: '<span><span class="dark-background">私たちはITとエンジニ<span class="accelerate">アリングのソリューションを結集し</span>、</span><br>全ての人々によりスマートな未来を創造していきます。</span>',
		explore: "GOPより探す",
		paragraph: '主要業界とテクノロジーを網羅した包括的なグローバルポートフォリオ',
		info: '戦略的なオファリングによるセールスの成功を通じて、ビジネスを革新、最適化、変革しましょう。',
		downloadPresentation: 'GOPで新しいオファーを作成する',
		publishedOffers: '最近公開されたオファー',
		lowDefinition: '低解像度でダウンロード（PDF）',
		highDefinition: '高解像度でダウンロード (PPT)',
		copyFileLink: 'ファイル URL をコピー',
		successCopyFileLink: 'ファイル URL を正常にコピーしました'
	},
	[LANGUAGE.es.short]: {
		title: '<span class="dark-background">Unimos <span class="accelerate">soluciones</span> de IT e Ingeniería</span><br> creando un futuro más inteligente para todos',
		explore: 'EXPLORA GOP',
		paragraph: 'Una amplia gama de Ofertas Globales que cubren sectores clave y prácticas tecnológicas',
		info: 'Innovemos, optimicemos y transformemos los negocios con éxito de ventas en ofertas estratégicas.',
		downloadPresentation: 'Crear una nueva oferta en GOP',
		publishedOffers: 'Ofertas publicadas recientemente',
		lowDefinition: 'Descargar en baja definición (PDF)',
		highDefinition: 'Descargar en alta definición (PPT)',
		copyFileLink: 'Copiar URL del archivo',
		successCopyFileLink: 'URL del archivo copiada con éxito'
	}
}
